import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileShareButton from './FileShareButton';
import queryString from 'query-string';

// http://localhost:3000/share-dialog/?identifier=Skli8vMcG&resourceSubtype=file
class ContainerShareDialog extends Component {
    constructor(props) {
        super(props);

        console.log('ContainerShareDialog querystring', props.location.search);
        const parsed = queryString.parse(props.location.search);
        this.state = {
            identifier: parsed.identifier,
            resourceSubtype: parsed.resourceSubtype,
            urlModifier: undefined,
        };
    }

    render() {
        const { identifier, resourceSubtype, urlModifier } = this.state;
        return (
            <div>
                {/* {'This is the Container Share Dialog for iOS'}
                {this.props.location.search} */}
                <FileShareButton
                    attachments={identifier ? [{ identifier, resourceSubtype, urlModifier }] : []}
                    notify={this.props.notify}
                    autoMode={true}
                />
            </div>
        );
    }
}
ContainerShareDialog.propTypes = {
    notify: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};

export default ContainerShareDialog;
